module.exports = __webpack_public_path__ + "img/icon-stamp.bada9839.png";